import Iconify from '@emfood/shared/src/components/iconify';

import { Box, Tooltip, IconButton } from '@mui/material';

interface Props {
  isDisabled?: boolean;
  isLoading?: boolean;
  isInCart?: boolean;
  onClick: () => void;
  quantity?: number;
  maxQuantity?: number;
}

export default function UpdateProductButton({
  isDisabled,
  isLoading,
  isInCart,
  onClick,
  quantity,
  maxQuantity,
}: Props) {
  const insufficientStock = !!quantity && !!maxQuantity && quantity > maxQuantity;

  // True when the row's quantity matches the cart — the "nothing to update, already in basket" state.
  // Callers that don't pass isInCart fall back to isDisabled to preserve prior behaviour.
  const showInCartIcon = isInCart ?? isDisabled;

  const disabled = isDisabled || insufficientStock || isLoading;

  const icon = isLoading
    ? 'eos-icons:loading'
    : insufficientStock
      ? 'solar:danger-triangle-bold'
      : showInCartIcon
        ? 'solar:cart-check-bold'
        : 'solar:refresh-circle-bold';

  const tooltipTitle = insufficientStock
    ? `Quantity must be ${maxQuantity} or less`
    : showInCartIcon
      ? 'In basket'
      : 'Update quantity';

  const ariaLabel = showInCartIcon ? 'In basket' : 'Update quantity';

  return (
    <Tooltip title={tooltipTitle}>
      {/* Box span keeps the tooltip working when the IconButton is disabled. */}
      <Box component="span">
        <IconButton onClick={onClick} disabled={disabled} aria-label={ariaLabel}>
          <Iconify icon={icon} />
        </IconButton>
      </Box>
    </Tooltip>
  );
}
